module.exports = __webpack_public_path__ + "img/img-23.a4e4cb14.png";